import { render, staticRenderFns } from "./ProjectPricing.vue?vue&type=template&id=43c774d2&"
import script from "./ProjectPricing.vue?vue&type=script&lang=js&"
export * from "./ProjectPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports